import apiClient from './apiClient';

export const getMetricThreadCatalog = async (params = {}, options = {}) => {
  const response = await apiClient.get('/threads/metric/catalog', {
    params,
    signal: options.signal,
  });
  return response.data;
};

export const calculateMetricThread = async (input, options = {}) => {
  const response = await apiClient.post('/threads/metric/calculate', input, {
    signal: options.signal,
  });
  return response.data;
};

export const calculateMetricPreDrill = async (input, options = {}) => {
  const response = await apiClient.post('/threads/metric/pre-drill/calculate', input, {
    signal: options.signal,
  });
  return response.data;
};
